import React, { Component } from 'react';
import authService from './api-authorization/AuthorizeService'
import { UncontrolledCollapse, Row, Col, Button, Spinner, Alert } from 'reactstrap';
import { BsFillExclamationDiamondFill } from "react-icons/bs";
import { Link } from 'react-router-dom';
import {
    CONFIG_BASE_API_URL,
} from '../constans';

export class TrainingStartExamPage extends Component {
    static displayName = TrainingStartExamPage.name;

    constructor(props) {
        super(props);
        this.state = { trainingDetail: null, loading: true };

        this.closeExamSessionClick = this.closeExamSessionClick.bind(this);
        this.renderTrainingDetail = this.renderTrainingDetail.bind(this);
    }

    componentDidMount() {
       
        this.populateTrainingDetailData();
    }

    closeExamSessionClick() {

        this.closePendingExam();
    }

    renderTrainingDetail() {
        if (this.state.trainingDetails?.isStarted === true) {
            return (
                <React.Fragment>
                    <div className="text-center my-5 mx-4 border shadow-sm p-4">
                        <h2 className="pt-5 pb-3">Wilt u uw vorige examen vervolgen?</h2>
                        <h6>Je was al bezig met het examen {this.state.trainingDetails.name}.</h6>
                        <h6>Klik hieronder om verder te gaan waar je gebleven was.</h6>

                        <Button className="my-4 mb-2" tag={Link} to={"/training/" + this.props.match.params.id + "/exam"} color="primary" size="lg">Vervolg examen</Button>
                        <p id="toggler">
                            <Button color="link" >Nee, ik start liever examen opnieuw.</Button>
                        </p>

                        <UncontrolledCollapse toggler="#toggler" color="danger">
                            <Alert color="danger">
                                <h3><BsFillExclamationDiamondFill /> Examen-sessie nog niet afgesloten</h3>
                                <hr/>
                                <div className="text-left">
                                    <p>U heeft een eerder gestart examen nog niet afgerond. U kunt ervoor kiezen om verder te gaan waar u bent gebleven, of u kunt de desbetreffende examen-sessie afsluiten en een nieuw examen starten.</p>
                                    <p>Let wel, als u de huidige examen-sessie afsluiten en een nieuwe start kan dit gevolgen hebben voor uw gemiddelde scores van deze training.</p>
                                </div>
                                <hr />
                                <div className="text-right">
                                    <Button color="danger" onClick={() => { this.closeExamSessionClick(); }}>Sluit huidige sessie en start een nieuw examen</Button>
                                </div>
                            </Alert>
                        </UncontrolledCollapse>

                    </div>
                </React.Fragment>
            );
        }

        return (<React.Fragment>
            <div className="text-center my-5 mx-4 border shadow-sm p-4">
                <h2 className="pt-5 pb-3">Klaar om het examen te starten?</h2>
                <h6>Je staat op het punt om een examen {this.state.trainingDetails.name} te starten.</h6>
                <h6>Dit examen bestaat uit {this.state.trainingDetails.numberOfQuestions} vragen.</h6>
                <Button className="my-4" tag={Link} to={"/training/" + this.props.match.params.id + "/exam"} color="primary" size="lg">
                    Start Examen
                </Button>
            </div>
        </React.Fragment>);

    }
    render() {
        let contents = this.state.loading
            ?
            <Row>
                <div className="col-sm center-loading-spinner">
                    <Spinner className="spinner-settings" type="border" color="primary" />
                    <div className="pt-4">Examen start data laden...</div>
                </div>
            </Row>
            : this.renderTrainingDetail();

        return (
            <React.Fragment>
                {contents}
            </React.Fragment>
        );
    }
    //GetAvailableTrainingsAsync
    async populateTrainingDetailData() {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/training/' + this.props.match.params.id + '/startdetails/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
            // voor nu niks later generieke toast laten zien met foutmelding
            return;
        }
        this.setState({ trainingDetails: data.responseData, loading: false });
    }

    async closePendingExam() {
        const token = await authService.getAccessToken();
        const response = await fetch(CONFIG_BASE_API_URL + '/training/' + this.props.match.params.id + '/actions/closependingresult', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        if (!data.isSuccess) {
            // voor nu niks later generieke toast laten zien met foutmelding
            return;    
        }

        this.props.history.push("/training/" + this.props.match.params.id + "/exam")
        //this.setState({ trainingDetails: data.responseData, loading: false });
    }
}